import { Tabs as TabsChakra, TabList, TabPanels, Tab, TabPanel, Flex, Text } from '@chakra-ui/react';
import { Visible } from 'components/Visible';
import { ReactNode, useState } from 'react';

type TabProps = {
    id: number;
    titleContent?: React.ReactElement;
    title?: string;
    subtitle?: string;
    content: ReactNode;
};

type TabsProps = {
   tabList: TabProps[];
   variant?: "line" | "enclosed" | "enclosed-colored" | "soft-rounded" | "solid-rounded" | "unstyled";
   unstyled?: boolean;
   alignment?: string;
   onChange?: (index: number) => void;
   width?: string;
   orientation?: "horizontal" | "vertical";
};

const Tabs = ({ tabList, variant = 'soft-rounded', unstyled = false, alignment = 'center', onChange, width, orientation = 'horizontal' }: TabsProps) => {
    const [index, setIndex] = useState(0);

    return (
        <TabsChakra orientation={orientation}  onChange={(index) => {onChange?.(index); setIndex(index);}} variant={variant}>
        <TabList justifyContent={alignment} position={orientation === 'vertical' ? 'fixed' : undefined}>
          {tabList.map((tab, key) =>
            <Tab
                width={width || ''}
                marginBottom={ orientation === 'vertical' ? 10 : 0}
                boxShadow={!unstyled ? index === key ? "0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)"
                : "0px 10px 15px -3px rgba(151, 151, 151, 0.1), 0px 4px 6px -2px rgba(151, 151, 151, 0.05)" : ''}
                key={tab.title}
                backgroundColor={!unstyled ? index === key ? 'white': "#F9F9F9" : ''}
                borderRadius={!unstyled ? "100px" :''}>
                <Flex direction='column'>
                    <Visible when={!tab.titleContent}>
                        <Text color={index === key ? 'black': "#6F6F6F"}>{tab.title}</Text>
                        {tab.subtitle && <Text>{tab.subtitle}</Text>}
                    </Visible>
                    <Visible when={!!tab.titleContent}>
                        {tab.titleContent}
                    </Visible>
                </Flex>
            </Tab>
           )}
        </TabList>
        <TabPanels>
            {tabList.map(tab =>
                <TabPanel key={tab.id}>
                    {tab.content}
                </TabPanel>
            )}  
        </TabPanels>
      </TabsChakra>
    )
  };

  export { Tabs };